import {
  GET_MATCHING_DATA,
  GET_MATCHING_DATA_SUCCESS,
  GET_MATCHING_DATA_FAIL,
} from "./actionTypes";

const initialState = {
  matchingData: {
    content: [],
    totalElements: 0,
  },
  loading: false,
  error: null,
};

const matchingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MATCHING_DATA:
      return { ...state, loading: true };

    case GET_MATCHING_DATA_SUCCESS: {
      // Deduplicate by candidateId — the ATS API may return multiple score
      // entries for the same candidate when scores are regenerated.
      // Keep only the first (most recent) entry per candidateId.
      const rawData = action.payload;
      let dedupedData = rawData;
      if (rawData && Array.isArray(rawData.content)) {
        const seen = new Set();
        const uniqueContent = rawData.content.filter((item) => {
          const cid = item.candidateId || item.id;
          if (seen.has(cid)) return false;
          seen.add(cid);
          return true;
        });
        dedupedData = {
          ...rawData,
          content: uniqueContent,
          totalElements: uniqueContent.length,
        };
      }
      return {
        ...state,
        loading: false,
        matchingData: dedupedData,
      };
    }

    case GET_MATCHING_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default matchingReducer;
